---
nb:
  ppa_pricing:
    charts:
      buy_back_cost_title: Kostnad for tilbakekjøp (EUR)
      buy_back_volume_title: Volum for tilbakekjøp i % av årsproduksjon
      portfolio_reference_title: Portefølje og referanseprofil
      profile_risk: Profilrisiko [%]
      simulated_revenue_development: Simulert inntektsutvikling
    factors:
      cannibalism: Kannibalisme
      cash_flow: Kontantstrøm
      liquidity: Likviditet
      price: Pris
      profile: Profil
      volume: Volum
    hedging_strategy: Sikringsstrategi for pris og risiko
    liquidity: Likviditet
    portfolio_attributes: Porteføljeattributter
    pricing: Prising
    pricing_and_risk: Produktprising og risiko
    risk_factors: Risikofaktorer
    risk_factors_additional: Status andre risikofaktorer
    risk_factors_mitigated: Status risikoreduserende tiltak
